





















































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { DistributorModel, DistributorsClient } from "@/diamond-support-api";

@Component
export default class AppNavigation extends Vue {
  @State("showNavigationBar", { namespace: "app" }) showNavigationBar: any;
  @Action("saveDistributorId", { namespace: "distributor" })
  saveDistributorId: any;
  @Getter("distributorId", { namespace: "distributor" }) distributorId: any;

  shown = false;
  distributorApi = new DistributorsClient();
  distributorDetails: DistributorModel[] = [];
  distributorDetail: DistributorModel | null = null;

  search = "";
  lastSearchUpdate = 0;
  selectedId: string | null = null;
  loading = false;

  navItems: any[] = [
    {
      text: "User Dashboard",
      icon: "mdi-view-dashboard-variant-outline",
      route: "/userDashboard",
      children: [
        {
          text: "Reminder List",
          icon: "mdi-card-account-details-outline",
          route: "/reminderList",
        },
      ],
    },
    {
      text: "Associate Detail",
      icon: "mdi-card-account-details-outline",
      route: "/associates",
    },
    {
      text: "DS+",
      icon: "mdi-file-chart",
      route: `/DSPlus`,
    },
    { text: "Diamond List", icon: "mdi-diamond-stone", route: "/diamondList" },
  ];

  mounted() {
    this.shown = this.showNavigationBar === true;
  }

  @Watch("showNavigationBar")
  onShowNavigationBar(val: boolean, oldVal: boolean) {
    this.shown = !this.shown;
  }

  @Watch("search")
  async onSearchChanged(val: string, oldVal: string) {
    if (!val) {
      this.distributorDetails = [];
      return;
    }
    this.loading = true;

    //reduce hits on the service
    this.lastSearchUpdate = new Date().getTime();

    let wait = (ms: number) =>
      new Promise((resolve) => setTimeout(resolve, ms));
    await wait(500);

    let now = new Date().getTime();

    if (now - this.lastSearchUpdate >= 500) {
      try {
        this.distributorDetails = await this.distributorApi.search(val, 1, 50);
        if(this.distributorDetails) this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    }
  }

  @Watch("selectedId")
  async onSelectedIdChanged(val: string | null, oldVal: string | null) {
    if (!val) return;
    this.saveDistributorId(val);
    this.$router.push({ path: `/associates/${val}/detail` }).catch(() => {});
    this.distributorDetails = [];
  }

  @Watch("$route.path")
  async onRouteChanged(val: string | null, oldVal: string | null) {
    if (
      oldVal?.includes("/associates/" && "/detail") &&
      val?.includes("/associates") &&
      val?.includes("/detail") == false &&
      this.distributorId
    ) {
      this.$router
        .push({ path: `/associates/${this.distributorId}/detail` })
        .catch(() => {});
    }
  }
}
